
<template>
  <view class="union-login">
    <image
      class="union-login-icon"
      src="https://ut-static.udache.com/webx/sfc/8P4puQvobKx3CRnGypis8.png"
    />
    <view class="union-login-text">登录12306账号，查看中转方案</view>
    <view class="union-login-button" bindtap="login">登录12306</view>
  </view>
</template>

<script>
import { createComponent } from '@didi/es-mpx-creator'
import { innerRouter, pagePath } from '@/common/jump'

createComponent({
  props: {},
  computed: {},
  methods: {
    login() {
      innerRouter.push(pagePath().LOGIN12306)
    }
  }
})
</script>

<style scoped lang="stylus">
.union-login
  display flex
  flex-direction column
  margin-top 80px
  align-items center
  &-icon
    height 55px
    width 55px
    margin-bottom 24px
  &-text
    font-family PingFangSC-Medium
    font-size 15px
    font-weight 500
    line-height 15px
    color #333
    margin-bottom 32px
  &-button
    padding 12.5px 21px
    background #338FFF
    font-family PingFangSC-Semibold
    font-size 16px
    font-weight 600
    line-height 16px
    text-align center
    color #FFFFFF
    border-radius 8px
</style>

<script name="json">
module.exports = {
  component: true,
  usingComponents: {}
}
</script>